// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimRepaymentAggregatedDto
 */
export interface IClaimRepaymentAggregatedDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimRepaymentAggregatedDto
     */
    employee_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentAggregatedDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentAggregatedDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentAggregatedDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimRepaymentAggregatedDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentAggregatedDto
     */
    claim_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentAggregatedDto
     */
    available_for_repayment_amount?: number;
}

/**
 * Check if a given object implements the IClaimRepaymentAggregatedDto interface.
 */
export function instanceOfIClaimRepaymentAggregatedDto(value: object): value is IClaimRepaymentAggregatedDto {
    return true;
}

export function IClaimRepaymentAggregatedDtoFromJSON(json: any): IClaimRepaymentAggregatedDto {
    return IClaimRepaymentAggregatedDtoFromJSONTyped(json, false);
}

export function IClaimRepaymentAggregatedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimRepaymentAggregatedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_name': json['employee_name'] == null ? undefined : json['employee_name'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'claim_amount': json['claim_amount'] == null ? undefined : json['claim_amount'],
        'available_for_repayment_amount': json['available_for_repayment_amount'] == null ? undefined : json['available_for_repayment_amount'],
    };
}

export function IClaimRepaymentAggregatedDtoToJSON(json: any): IClaimRepaymentAggregatedDto {
    return IClaimRepaymentAggregatedDtoToJSONTyped(json, false);
}

export function IClaimRepaymentAggregatedDtoToJSONTyped(value?: IClaimRepaymentAggregatedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_name': value['employee_name'],
        'claim_id': value['claim_id'],
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'claim_amount': value['claim_amount'],
        'available_for_repayment_amount': value['available_for_repayment_amount'],
    };
}

